
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import api from '../../api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TotalActiveUsersChart = () => {
  const [data, setData] = useState({
    labels: ["1D", "1W", "1M", "3M", "6M", "1Y"],
    datasets: [],
  });
  const [themeColors, setThemeColors] = useState({});

  const token =
    localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

  // ✅ Load CSS variables dynamically
  const loadThemeColors = () => {
    const styles = getComputedStyle(document.documentElement);
    return {
      text: styles.getPropertyValue("--dark-color").trim(),
      grid: styles.getPropertyValue("--border-color").trim(),
      bg: styles.getPropertyValue("--background-color").trim(),
    };
  };

  useEffect(() => {
    setThemeColors(loadThemeColors());

    // ✅ Update colors when theme changes
    const observer = new MutationObserver(() => {
      setThemeColors(loadThemeColors());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/auth/active-users-over-time`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const counts = res.data;

        setData({
          labels: ["1D", "1W", "1M", "3M", "6M", "1Y"],
          datasets: [
            {
              label: "Super Admin",
              data: Object.values(counts.Superadmin),
              backgroundColor: "#D4D4D4", // stays light gray
              borderRadius: 4,
              barThickness: 20,
            },
            {
              label: "Admin",
              data: Object.values(counts.Admin),
              backgroundColor: "#6B7280", // stays gray
              borderRadius: 4,
              barThickness: 20,
            },
            {
              label: "Users",
              data: Object.values(counts.User),
              backgroundColor: "#000000", // stays black
              borderRadius: 4,
              barThickness: 20,
            },
          ],
        });
      } catch (err) {
        console.error("Failed to fetch active users over time:", err);
      }
    };

    fetchData();
  }, [token]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: themeColors.text, // 👈 legend text adapts
          font: {
            size: 13,
            weight: "500",
          },
        },
      },
      tooltip: {
        backgroundColor: themeColors.bg, // 👈 tooltip background
        titleColor: themeColors.text, // 👈 tooltip title text
        bodyColor: themeColors.text, // 👈 tooltip body text
        borderColor: themeColors.grid,
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        ticks: {
          color: themeColors.text, // 👈 X-axis labels
        },
        grid: {
          color: themeColors.grid, // 👈 grid lines
        },
      },
      y: {
        ticks: {
          color: themeColors.text, // 👈 Y-axis labels
        },
        grid: {
          color: themeColors.grid,
        },
      },
    },
  };

  return (
    <div className="chart-card p-4 shadow-sm rounded profile mb-4">
      <h4 className="fw-bold mb-4">
        <span className="border-start border-4 line refresh-prompts ps-2">
          Total Active Users
        </span>
      </h4>
      <div style={{ height: "320px", width: "100%" }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default TotalActiveUsersChart;
